module.exports = __webpack_public_path__ + "img/save-icon.50180ccc.svg";